/**
 * Labstep
 *
 * @module components/Signature/List
 * @desc Signature list
 */

import { SignatureListEntityStateComponent } from 'labstep-web/components/Signature/List/EntityState/Component';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { EntityUser } from 'labstep-web/models/entity-user.model';
import type React from 'react';
import type { ISignatureListEntityStateContainerProps } from './types';

export const SignatureListEntityStateContainer: React.FC<
  ISignatureListEntityStateContainerProps
> = (props) => (
  <ReadOnMountHOC
    type="cursor"
    pagination={{ loader: 'placeholder' }}
    entityName={EntityUser.entityName}
    params={{
      experiment_workflow_id: props.experimentWorkflow.id,
      count: 100,
    }}
  >
    {({ entities }) => (
      <SignatureListEntityStateComponent
        {...props}
        entityUsers={entities.filter(
          (e) => e.is_contributor || e.is_assigned,
        )}
      />
    )}
  </ReadOnMountHOC>
);
